import { ChevronDown, MapPin } from "lucide-react";
import { restaurant } from "../mock";
import { useLang } from "../i18n";

export default function Hero() {
  const { t } = useLang();
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {/* Blurred bar background with slow zoom */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/hero-bar.jpg"
          alt="Quattro Tavoli Bar"
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-sm animate-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2A2420]/75 via-[#2A2420]/45 to-[#2A2420]/85" />
        <div className="absolute inset-0 bg-[#2A2420]/25" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-5xl mx-auto px-6 flex flex-col items-center justify-center text-center">
        <span className="fade-up-1 inline-flex items-center gap-2 text-[#F0D9A7] text-xs sm:text-sm uppercase tracking-[0.4em] mb-6">
          <span className="w-8 h-px bg-[#F0D9A7]" />
          {t("hero.badge")}
          <span className="w-8 h-px bg-[#F0D9A7]" />
        </span>

        <h1 className="fade-up-2 font-courier text-white text-5xl sm:text-7xl lg:text-8xl font-700 leading-[0.95] tracking-tight">
          Quattro <span className="not-italic text-white">Tavoli</span>
        </h1>

        <p className="fade-up-3 mt-7 max-w-xl text-white/85 text-lg sm:text-xl font-serif-alt font-500 leading-relaxed">
          {t("hero.subtitle")}
        </p>

        <div className="fade-up-4 mt-10 flex items-center justify-center">
          <button
            onClick={() => scrollTo("#visit")}
            className="px-9 py-3.5 rounded-full bg-[#9C3B2E] text-[#FAF4EA] font-500 tracking-wide hover:bg-[#9C3B2E] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_-10px_rgba(181,86,58,0.8)]"
          >
            {t("nav.reserve")}
          </button>
        </div>

        <div className="fade-up-4 mt-9 flex items-center gap-2 text-white/70 text-sm">
          <MapPin className="w-4 h-4 text-[#F0D9A7]" />
          {restaurant.address}
        </div>
      </div>

      {/* Scroll cue */}
      <button
        onClick={() => scrollTo("#about")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/70 hover:text-white transition-colors animate-bounce"
        aria-label="Nach unten scrollen"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
